"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _prefix = _interopRequireDefault(require("../prefix"));

var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/lib/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("react-bootstrap/lib/Popover"));

var _Tooltip = _interopRequireDefault(require("react-bootstrap/lib/Tooltip"));
/** Panels that reveal additional details */


var Popover = function Popover(_ref) {
  var children = _ref.children,
      className = _ref.className,
      htmlId = _ref.htmlId,
      popoverContent = _ref.popoverContent,
      position = _ref.position,
      trigger = _ref.trigger,
      tooltip = _ref.tooltip;
  var popover = tooltip ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    id: "".concat(htmlId, "-tooltip"),
    bsClass: "".concat(_prefix["default"], "tooltip"),
    className: className
  }, popoverContent) : /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    id: "".concat(htmlId, "-popover"),
    bsClass: "".concat(_prefix["default"], "popover"),
    className: className
  }, popoverContent);
  var wrappedComponent = typeof children === "string" ? /*#__PURE__*/_react["default"].createElement("span", null, children) : children;
  var rootClose = false;

  if (Array.isArray(trigger) && trigger.includes("outsideClick")) {
    rootClose = true;
    trigger.splice(trigger.indexOf("outsideClick"), 1);
  }

  return /*#__PURE__*/_react["default"].createElement(_OverlayTrigger["default"], {
    id: htmlId + "-popover-trigger",
    overlay: popover,
    placement: position,
    trigger: trigger,
    rootClose: rootClose
  }, wrappedComponent);
};

Popover.defaultProps = {
  position: "bottom",
  tooltip: false,
  trigger: ["click", "outsideClick"]
};
var _default = Popover;
exports["default"] = _default;